import React, { useState, useEffect, useRef } from 'react'
import './tooltap.scss';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography, FormControl, OutlinedInput, InputAdornment, InputLabel, Grid, Popper, MenuItem, ImageListItem, ImageListItemBar, ImageList, CircularProgress, Select, Button, TextField, InputBase } from "@mui/material"
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { ClickAwayListener } from '@mui/base';
import VideocamIcon from '@mui/icons-material/Videocam';

import SearchIcon from '@mui/icons-material/Search';
import { SectionHeader } from './common/section.header';
import {
  getStockSearchKeyword,
  getStockData,
  createStock,
  updateStock,
  UploadAssets,
  getPopularPexelsData,
  getPexelsData,
  getPopularPexelsImages,
  getPexelsImageSearch,
  getPexelsImageData,
  getPixaBayStockSearch,
  getPopularPixaBayStockData,
  getPopularPixabayImageStocks,
  getPixabayImageSearchStocks,
  getPixabayImageStock,
  getFreeSoundSearch,
  getFreeSoundData,
  getProjectJSON
} from '../../../axios/ApiProvider';
import { GetProjectUUID } from '../../../assets/script/commonFunction';
import { getNewStockInformation, getThumbnailsInfo, getImageInformation, getNewAudioInformation, getNewAudioStockInformation } from '../webGL/commonFunc';
import { VideoElements_Store, audioElements_Store, dataLoaded_Store, imageElements_Store } from '../../../store/actions/webgldata';
import { changedJSON_Store, ProjectJSON_Store, thumbNails_Store } from '../../../store/actions/projectdata';
import { getMaxZIndex } from '../commonFunction';
import { changeZeroSecond } from '../commonFunction';
import { localeForPexles, mimeTypes } from './tooltap.config';
import { v4 as uuidv4 } from 'uuid';
import { webGlSizeOptions } from "../../video-edit/videoEdit.config"
import pexelsVideoLogo from "../../../assets/image/Logos/pexelVideo.png"
import pexelsImageLogo from "../../../assets/image/Logos/pexelImage.png";
import pixabayVideoLogo from "../../../assets/image/Logos/pixabayVideo.png";
import pixabayImageLogo from "../../../assets/image/Logos/pixabayImage.png";
import freeSoundLogo from "../../../assets/image/Logos/freeSound.png";
import stockLogo from "../../../assets/image/Logos/stock_logo.png"
import { duration } from 'moment';

import freesoundIcon from "../../../assets/image/Logos/freesound.svg";
import pexelsIcon from "../../../assets/image/Logos/pexels.svg";
import pixabayIcon from "../../../assets/image/Logos/pixabay.svg";
import adobeStockIcon from "../../../assets/image/Logos/adobe-stock.svg";
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';


import { AdobeStock } from './stocks/adobeStock';
import { PexelsVideo } from './stocks/pexelsVideo';
import { PexelsImage } from './stocks/pexelsImage';
import { PixaBayVideo } from './stocks/pixabayVideo';
import { PixabayImage } from './stocks/pixabayImage';
import { FreeSound } from './stocks/freeSound';

export const TooltapStock = () => {
  const [stockMenu, setStockMenu] = useState("pixabayVideo");
  const [stockFilterVisibility, setStockFilterVisibility] = useState('none');

  const handleStockChange = (e) => setStockMenu(e.target.value);

  const stockProviders = [
    { value: 'pixabayVideo', label: 'Pixabay Video', icon: pixabayIcon, component: PixaBayVideo },
    { value: 'pexelsVideo', label: 'Pexels Video', icon: pexelsIcon, component: PexelsVideo },
    { value: 'stock', label: 'Adobe Stock', icon: adobeStockIcon, component: AdobeStock },
    { value: 'pixabayImage', label: 'Pixabay Image', icon: pixabayIcon, component: PixabayImage },
    { value: 'pexelsImage', label: 'Pexels Image', icon: pexelsIcon, component: PexelsImage },
    { value: 'freesound', label: 'Freesound Audio', icon: freesoundIcon, component: FreeSound },
  ];

  const handleStockFilterVisibility = () => {
    if (stockFilterVisibility === 'none') {
      setStockFilterVisibility('flex');
    } else {
      setStockFilterVisibility('none');
    }
  }

  useEffect(() => {
    setStockFilterVisibility('none');

  }, [stockMenu])

  return (
    <>
      <FormControl className='select-stock-content-wrapper'>
        <InputLabel id="stock-content">Select Stock Content Provider</InputLabel>
        <Select
          labelId="stock-content"
          value={stockMenu}
          label="Select Stock Content Provider"
          onChange={handleStockChange}
        >
          {stockProviders.map(({ value, label, icon }) => (
            <MenuItem
              key={value}
              value={value}
              sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontFamily: "'Poppins', sans-serif" }}
            >
              {label}
              <img src={icon} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
            </MenuItem>
          ))}
        </Select>
    
        <Button
        variant='contained'
        onClick={handleStockFilterVisibility} 
        sx={{ mt: 1, display: stockMenu === "stock" || stockMenu === "freesound" ? "none" : "block" }}
        >
          {stockFilterVisibility === 'none' ? <TuneIcon /> : <CloseIcon />}
          MORE OPTIONS
        </Button>
      </FormControl>

      {stockProviders.map(({ value, component: Component }) =>
        stockMenu === value ? <Component key={value} stockFilterVisibility={stockFilterVisibility} /> : null
      )}
    </>
  )
}

